import { render, staticRenderFns } from "./Regra.vue?vue&type=template&id=e355d99e&scoped=true"
import script from "./Regra.vue?vue&type=script&lang=js"
export * from "./Regra.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=e355d99e&prod&scoped=true&lang=css&external"
import style1 from "./Regra.vue?vue&type=style&index=1&id=e355d99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e355d99e",
  null
  
)

export default component.exports